var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"nav"}}),_c('div',{staticClass:"position-relative d-flex justify-content-center"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('HelpModal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }